import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchDashboardData, selectDashboard } from '../../store/slices/dashboardSlice';
import { setUnreadCount } from '../../store/slices/chatHistorySlice';

export const useDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { dashboardData, isLoading, error } = useSelector(selectDashboard);
  if (dashboardData) {
    const unreadChatLogs = dashboardData?.chatlogs?.unread || 0;
    dispatch(setUnreadCount(unreadChatLogs));
  }
  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const refetch = useCallback(() => {
    if (selectedOrganizationId) {
      dispatch(fetchDashboardData(selectedOrganizationId));
    }
  }, [dispatch, selectedOrganizationId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    dashboardData,
    isLoading,
    error,
    selectedOrganizationId,
    refetch,
  };
};
